/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CheckContactsRequest } from '../models';
// @ts-ignore
import { ContactResponse } from '../models';
// @ts-ignore
import { Customer } from '../models';
// @ts-ignore
import { CustomerPreferences } from '../models';
// @ts-ignore
import { CustomerResult } from '../models';
// @ts-ignore
import { CustomerSuggestionResponse } from '../models';
// @ts-ignore
import { CustomerTenantDetails } from '../models';
// @ts-ignore
import { Email } from '../models';
// @ts-ignore
import { FindCustomerLinkedTenantsRequest } from '../models';
// @ts-ignore
import { LevelProviderRedirect } from '../models';
// @ts-ignore
import { LinkLevelProvider } from '../models';
// @ts-ignore
import { Phone } from '../models';
// @ts-ignore
import { Privacy } from '../models';
// @ts-ignore
import { SimpleCustomer } from '../models';
// @ts-ignore
import { SportProviderLevel } from '../models';
// @ts-ignore
import { Tenant } from '../models';
// @ts-ignore
import { UpdateCustomerRequest } from '../models';
// @ts-ignore
import { Url } from '../models';
/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a customer like
         * @param {string} id Target id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerLike: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addCustomerLike', 'id', id)
            const localVarPath = `/api/customer/like/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new email
         * @param {string} value The email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmail: async (value: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'value' is not null or undefined
            assertParamExists('addEmail', 'value', value)
            const localVarPath = `/api/customer/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new phone
         * @param {string} prefix The area code
         * @param {string} value The phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPhone: async (prefix: string, value: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefix' is not null or undefined
            assertParamExists('addPhone', 'prefix', prefix)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('addPhone', 'value', value)
            const localVarPath = `/api/customer/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add tenant to customer preferences
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenantToCustomerFavorites: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTenantToCustomerFavorites', 'id', id)
            const localVarPath = `/api/customer/preferences/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Let customers to change password
         * @param {string} currentPassword The current customer password
         * @param {string} newPassword The new password chose by customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (currentPassword: string, newPassword: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentPassword' is not null or undefined
            assertParamExists('changePassword', 'currentPassword', currentPassword)
            // verify required parameter 'newPassword' is not null or undefined
            assertParamExists('changePassword', 'newPassword', newPassword)
            const localVarPath = `/api/customer/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currentPassword !== undefined) {
                localVarQueryParameter['currentPassword'] = currentPassword;
            }

            if (newPassword !== undefined) {
                localVarQueryParameter['newPassword'] = newPassword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check contacts against Taykus customers
         * @param {CheckContactsRequest} checkContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContacts: async (checkContactsRequest: CheckContactsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkContactsRequest' is not null or undefined
            assertParamExists('checkContacts', 'checkContactsRequest', checkContactsRequest)
            const localVarPath = `/api/v2/customers/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a request link customer to a tenant
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedTenant: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createLinkedTenant', 'id', id)
            const localVarPath = `/api/customer/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete like by id
         * @param {string} id Target id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerLike: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomerLike', 'id', id)
            const localVarPath = `/api/customer/like/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an email by id
         * @param {number} id The email id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmail: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEmail', 'id', id)
            const localVarPath = `/api/customer/email/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete tenant customer relation
         * @param {string} id tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkedTenant: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLinkedTenant', 'id', id)
            const localVarPath = `/api/customer/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a phone by id
         * @param {number} id The phone id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhone: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePhone', 'id', id)
            const localVarPath = `/api/customer/phone/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove tenant from customer preferences
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenantFromCustomerFavorites: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTenantFromCustomerFavorites', 'id', id)
            const localVarPath = `/api/customer/preferences/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a email as customer default email
         * @param {number} id The email id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doDefaultEmail: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doDefaultEmail', 'id', id)
            const localVarPath = `/api/customer/email/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a phone as customer default phone
         * @param {number} id The phone id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doDefaultPhone: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doDefaultPhone', 'id', id)
            const localVarPath = `/api/customer/phone/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search customers likes from a customer
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomerLikeById: async (start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findCustomerLikeById', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findCustomerLikeById', 'size', size)
            const localVarPath = `/api/customer/like`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search customers filtering by name, phone or email
         * @param {string} name The customer name, phone or email
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomers: async (name: string, start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('findCustomers', 'name', name)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findCustomers', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findCustomers', 'size', size)
            const localVarPath = `/api/customer/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the customer emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmailByCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the customer tenants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLinkedTenantByCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find customer linked tenants
         * @param {FindCustomerLinkedTenantsRequest} findCustomerLinkedTenantsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLinkedTenantsByCustomer: async (findCustomerLinkedTenantsRequest: FindCustomerLinkedTenantsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findCustomerLinkedTenantsRequest' is not null or undefined
            assertParamExists('findLinkedTenantsByCustomer', 'findCustomerLinkedTenantsRequest', findCustomerLinkedTenantsRequest)
            const localVarPath = `/api/v2/customers/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findCustomerLinkedTenantsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the customer phones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPhoneByCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the customer results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerResults: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user linked tenant details
         * @param {string} id The tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTenantDetails: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerTenantDetails', 'id', id)
            const localVarPath = `/api/customer/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get level for provider and sport
         * @param {number} id The level provider id
         * @param {number} sportId The sport code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevelForProviderAndSport: async (id: number, sportId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLevelForProviderAndSport', 'id', id)
            // verify required parameter 'sportId' is not null or undefined
            assertParamExists('getLevelForProviderAndSport', 'sportId', sportId)
            const localVarPath = `/api/customer/levels/provider/{id}/sport/{sportId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sportId"}}`, encodeURIComponent(String(sportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the customer preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer privacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/privacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get level provider redirect URL
         * @param {number} id The level provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirectURL: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRedirectURL', 'id', id)
            const localVarPath = `/api/customer/levels/provider/{id}/redirect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer suggestions
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions: async (size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getSuggestions', 'size', size)
            const localVarPath = `/api/v2/customers/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start recover password process
         * @param {string} email Address where the restore password email will be sent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initRestorePassword: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('initRestorePassword', 'email', email)
            const localVarPath = `/api/customer/restore/password/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link level provider account
         * @param {number} id The level provider id
         * @param {LinkLevelProvider} linkLevelProvider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkLevelProviderAccount: async (id: number, linkLevelProvider: LinkLevelProvider, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('linkLevelProviderAccount', 'id', id)
            // verify required parameter 'linkLevelProvider' is not null or undefined
            assertParamExists('linkLevelProviderAccount', 'linkLevelProvider', linkLevelProvider)
            const localVarPath = `/api/customer/levels/provider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkLevelProvider, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a customer device
         * @param {string} token The FCM token of the device device
         * @param {string} [os] The Operative System of the device
         * @param {string} [version] The Operative System version
         * @param {string} [description] A short description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice: async (token: string, os?: string, version?: string, description?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('registerDevice', 'token', token)
            const localVarPath = `/api/customer/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Let customers to recover password
         * @param {string} token token send by mail
         * @param {string} newPassword The new password chose by customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePassword: async (token: string, newPassword: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('restorePassword', 'token', token)
            // verify required parameter 'newPassword' is not null or undefined
            assertParamExists('restorePassword', 'newPassword', newPassword)
            const localVarPath = `/api/customer/restore/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (newPassword !== undefined) {
                localVarQueryParameter['newPassword'] = newPassword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a notification
         * @param {string} title The title
         * @param {string} body The body
         * @param {Array<string>} tokens The target tokens
         * @param {string} bookingId The booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification: async (title: string, body: string, tokens: Array<string>, bookingId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('sendNotification', 'title', title)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendNotification', 'body', body)
            // verify required parameter 'tokens' is not null or undefined
            assertParamExists('sendNotification', 'tokens', tokens)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('sendNotification', 'bookingId', bookingId)
            const localVarPath = `/api/customer/device/simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (body !== undefined) {
                localVarQueryParameter['body'] = body;
            }

            if (tokens) {
                localVarQueryParameter['tokens'] = tokens;
            }

            if (bookingId !== undefined) {
                localVarQueryParameter['bookingId'] = bookingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a notification to all customers
         * @param {string} title The title
         * @param {string} body The body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationToAllCustomers: async (title: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('sendNotificationToAllCustomers', 'title', title)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendNotificationToAllCustomers', 'body', body)
            const localVarPath = `/api/customer/device/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (body !== undefined) {
                localVarQueryParameter['body'] = body;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modify customer data
         * @param {UpdateCustomerRequest} updateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateCustomerRequest: UpdateCustomerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCustomerRequest' is not null or undefined
            assertParamExists('update', 'updateCustomerRequest', updateCustomerRequest)
            const localVarPath = `/api/v2/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the sport level of a customer
         * @param {number} sport The sport of the level
         * @param {number} level The value of the level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerLevel: async (sport: number, level: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sport' is not null or undefined
            assertParamExists('updateCustomerLevel', 'sport', sport)
            // verify required parameter 'level' is not null or undefined
            assertParamExists('updateCustomerLevel', 'level', level)
            const localVarPath = `/api/customer/level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sport !== undefined) {
                localVarQueryParameter['sport'] = sport;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Let customers to change the full name
         * @param {string} fullname The current customer password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFullName: async (fullname: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fullname' is not null or undefined
            assertParamExists('updateFullName', 'fullname', fullname)
            const localVarPath = `/api/customer/fullname`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fullname !== undefined) {
                localVarQueryParameter['fullname'] = fullname;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the customer gender
         * @param {number} gender The gender of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGender: async (gender: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gender' is not null or undefined
            assertParamExists('updateGender', 'gender', gender)
            const localVarPath = `/api/customer/gender`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Let customers to change the nickname
         * @param {string} nickname The current customer password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNickName: async (nickname: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nickname' is not null or undefined
            assertParamExists('updateNickName', 'nickname', nickname)
            const localVarPath = `/api/customer/nickname`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nickname !== undefined) {
                localVarQueryParameter['nickname'] = nickname;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update phone
         * @param {string} prefix The area code
         * @param {string} value The phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhone: async (prefix: string, value: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefix' is not null or undefined
            assertParamExists('updatePhone', 'prefix', prefix)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('updatePhone', 'value', value)
            const localVarPath = `/api/v2/customers/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the customer preferences
         * @param {CustomerPreferences} customerPreferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences: async (customerPreferences: CustomerPreferences, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPreferences' is not null or undefined
            assertParamExists('updatePreferences', 'customerPreferences', customerPreferences)
            const localVarPath = `/api/customer/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerPreferences, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update customer privacy
         * @param {Privacy} privacy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacy: async (privacy: Privacy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'privacy' is not null or undefined
            assertParamExists('updatePrivacy', 'privacy', privacy)
            const localVarPath = `/api/customer/privacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(privacy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Let customers to change their image
         * @param {any} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: async (image: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('uploadImage', 'image', image)
            const localVarPath = `/api/customer/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Service to verify email process
         * @param {string} token The token received to verify email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyEmail', 'token', token)
            const localVarPath = `/api/customer/email/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Service to verify phone process
         * @param {string} token The token received to verify phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhone: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyPhone', 'token', token)
            const localVarPath = `/api/customer/phone/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a customer like
         * @param {string} id Target id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomerLike(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomerLike(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a new email
         * @param {string} value The email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmail(value: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Email>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEmail(value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a new phone
         * @param {string} prefix The area code
         * @param {string} value The phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPhone(prefix: string, value: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Phone>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPhone(prefix, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add tenant to customer preferences
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTenantToCustomerFavorites(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTenantToCustomerFavorites(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Let customers to change password
         * @param {string} currentPassword The current customer password
         * @param {string} newPassword The new password chose by customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(currentPassword: string, newPassword: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(currentPassword, newPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check contacts against Taykus customers
         * @param {CheckContactsRequest} checkContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkContacts(checkContactsRequest: CheckContactsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContactResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkContacts(checkContactsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a request link customer to a tenant
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLinkedTenant(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Url>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLinkedTenant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete like by id
         * @param {string} id Target id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerLike(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerLike(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an email by id
         * @param {number} id The email id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmail(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete tenant customer relation
         * @param {string} id tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLinkedTenant(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLinkedTenant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a phone by id
         * @param {number} id The phone id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePhone(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePhone(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove tenant from customer preferences
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTenantFromCustomerFavorites(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTenantFromCustomerFavorites(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark a email as customer default email
         * @param {number} id The email id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doDefaultEmail(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doDefaultEmail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark a phone as customer default phone
         * @param {number} id The phone id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doDefaultPhone(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doDefaultPhone(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search customers likes from a customer
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCustomerLikeById(start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleCustomer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCustomerLikeById(start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search customers filtering by name, phone or email
         * @param {string} name The customer name, phone or email
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCustomers(name: string, start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleCustomer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCustomers(name, start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all the customer emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEmailByCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Email>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEmailByCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all the customer tenants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLinkedTenantByCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tenant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLinkedTenantByCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find customer linked tenants
         * @param {FindCustomerLinkedTenantsRequest} findCustomerLinkedTenantsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLinkedTenantsByCustomer(findCustomerLinkedTenantsRequest: FindCustomerLinkedTenantsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tenant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLinkedTenantsByCustomer(findCustomerLinkedTenantsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all the customer phones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPhoneByCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Phone>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPhoneByCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the customer results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerResults(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerResults(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user linked tenant details
         * @param {string} id The tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerTenantDetails(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerTenantDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerTenantDetails(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get level for provider and sport
         * @param {number} id The level provider id
         * @param {number} sportId The sport code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLevelForProviderAndSport(id: number, sportId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SportProviderLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLevelForProviderAndSport(id, sportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the customer preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferences(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferences(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer privacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivacy(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Privacy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivacy(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get level provider redirect URL
         * @param {number} id The level provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedirectURL(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LevelProviderRedirect>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedirectURL(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer suggestions
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestions(size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerSuggestionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestions(size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start recover password process
         * @param {string} email Address where the restore password email will be sent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initRestorePassword(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initRestorePassword(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Link level provider account
         * @param {number} id The level provider id
         * @param {LinkLevelProvider} linkLevelProvider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkLevelProviderAccount(id: number, linkLevelProvider: LinkLevelProvider, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkLevelProviderAccount(id, linkLevelProvider, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register a customer device
         * @param {string} token The FCM token of the device device
         * @param {string} [os] The Operative System of the device
         * @param {string} [version] The Operative System version
         * @param {string} [description] A short description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerDevice(token: string, os?: string, version?: string, description?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerDevice(token, os, version, description, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Let customers to recover password
         * @param {string} token token send by mail
         * @param {string} newPassword The new password chose by customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restorePassword(token: string, newPassword: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restorePassword(token, newPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send a notification
         * @param {string} title The title
         * @param {string} body The body
         * @param {Array<string>} tokens The target tokens
         * @param {string} bookingId The booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNotification(title: string, body: string, tokens: Array<string>, bookingId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNotification(title, body, tokens, bookingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send a notification to all customers
         * @param {string} title The title
         * @param {string} body The body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNotificationToAllCustomers(title: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNotificationToAllCustomers(title, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Modify customer data
         * @param {UpdateCustomerRequest} updateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateCustomerRequest: UpdateCustomerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateCustomerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the sport level of a customer
         * @param {number} sport The sport of the level
         * @param {number} level The value of the level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerLevel(sport: number, level: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerLevel(sport, level, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Let customers to change the full name
         * @param {string} fullname The current customer password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFullName(fullname: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFullName(fullname, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the customer gender
         * @param {number} gender The gender of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGender(gender: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGender(gender, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Let customers to change the nickname
         * @param {string} nickname The current customer password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNickName(nickname: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNickName(nickname, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update phone
         * @param {string} prefix The area code
         * @param {string} value The phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhone(prefix: string, value: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Phone>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhone(prefix, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the customer preferences
         * @param {CustomerPreferences} customerPreferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreferences(customerPreferences: CustomerPreferences, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreferences(customerPreferences, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update customer privacy
         * @param {Privacy} privacy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrivacy(privacy: Privacy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrivacy(privacy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Let customers to change their image
         * @param {any} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImage(image: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImage(image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Service to verify email process
         * @param {string} token The token received to verify email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Service to verify phone process
         * @param {string} token The token received to verify phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPhone(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPhone(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a customer like
         * @param {string} id Target id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerLike(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.addCustomerLike(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new email
         * @param {string} value The email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmail(value: string, options?: any): AxiosPromise<Email> {
            return localVarFp.addEmail(value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new phone
         * @param {string} prefix The area code
         * @param {string} value The phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPhone(prefix: string, value: string, options?: any): AxiosPromise<Phone> {
            return localVarFp.addPhone(prefix, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add tenant to customer preferences
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenantToCustomerFavorites(id: string, options?: any): AxiosPromise<CustomerPreferences> {
            return localVarFp.addTenantToCustomerFavorites(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Let customers to change password
         * @param {string} currentPassword The current customer password
         * @param {string} newPassword The new password chose by customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(currentPassword: string, newPassword: string, options?: any): AxiosPromise<Customer> {
            return localVarFp.changePassword(currentPassword, newPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check contacts against Taykus customers
         * @param {CheckContactsRequest} checkContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkContacts(checkContactsRequest: CheckContactsRequest, options?: any): AxiosPromise<Array<ContactResponse>> {
            return localVarFp.checkContacts(checkContactsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a request link customer to a tenant
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedTenant(id: string, options?: any): AxiosPromise<Url> {
            return localVarFp.createLinkedTenant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(options?: any): AxiosPromise<Customer> {
            return localVarFp.deleteCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete like by id
         * @param {string} id Target id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerLike(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCustomerLike(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an email by id
         * @param {number} id The email id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmail(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEmail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete tenant customer relation
         * @param {string} id tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkedTenant(id: string, options?: any): AxiosPromise<Customer> {
            return localVarFp.deleteLinkedTenant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a phone by id
         * @param {number} id The phone id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhone(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePhone(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove tenant from customer preferences
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenantFromCustomerFavorites(id: string, options?: any): AxiosPromise<CustomerPreferences> {
            return localVarFp.deleteTenantFromCustomerFavorites(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a email as customer default email
         * @param {number} id The email id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doDefaultEmail(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.doDefaultEmail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a phone as customer default phone
         * @param {number} id The phone id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doDefaultPhone(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.doDefaultPhone(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search customers likes from a customer
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomerLikeById(start: number, size: number, options?: any): AxiosPromise<Array<SimpleCustomer>> {
            return localVarFp.findCustomerLikeById(start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search customers filtering by name, phone or email
         * @param {string} name The customer name, phone or email
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomers(name: string, start: number, size: number, options?: any): AxiosPromise<Array<SimpleCustomer>> {
            return localVarFp.findCustomers(name, start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the customer emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmailByCustomer(options?: any): AxiosPromise<Array<Email>> {
            return localVarFp.findEmailByCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the customer tenants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLinkedTenantByCustomer(options?: any): AxiosPromise<Array<Tenant>> {
            return localVarFp.findLinkedTenantByCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find customer linked tenants
         * @param {FindCustomerLinkedTenantsRequest} findCustomerLinkedTenantsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLinkedTenantsByCustomer(findCustomerLinkedTenantsRequest: FindCustomerLinkedTenantsRequest, options?: any): AxiosPromise<Array<Tenant>> {
            return localVarFp.findLinkedTenantsByCustomer(findCustomerLinkedTenantsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the customer phones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPhoneByCustomer(options?: any): AxiosPromise<Array<Phone>> {
            return localVarFp.findPhoneByCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(options?: any): AxiosPromise<Customer> {
            return localVarFp.getCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the customer results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerResults(options?: any): AxiosPromise<Array<CustomerResult>> {
            return localVarFp.getCustomerResults(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user linked tenant details
         * @param {string} id The tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTenantDetails(id: string, options?: any): AxiosPromise<CustomerTenantDetails> {
            return localVarFp.getCustomerTenantDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get level for provider and sport
         * @param {number} id The level provider id
         * @param {number} sportId The sport code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevelForProviderAndSport(id: number, sportId: number, options?: any): AxiosPromise<SportProviderLevel> {
            return localVarFp.getLevelForProviderAndSport(id, sportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the customer preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences(options?: any): AxiosPromise<CustomerPreferences> {
            return localVarFp.getPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer privacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacy(options?: any): AxiosPromise<Privacy> {
            return localVarFp.getPrivacy(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get level provider redirect URL
         * @param {number} id The level provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirectURL(id: number, options?: any): AxiosPromise<LevelProviderRedirect> {
            return localVarFp.getRedirectURL(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer suggestions
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions(size: number, options?: any): AxiosPromise<Array<CustomerSuggestionResponse>> {
            return localVarFp.getSuggestions(size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start recover password process
         * @param {string} email Address where the restore password email will be sent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initRestorePassword(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.initRestorePassword(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link level provider account
         * @param {number} id The level provider id
         * @param {LinkLevelProvider} linkLevelProvider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkLevelProviderAccount(id: number, linkLevelProvider: LinkLevelProvider, options?: any): AxiosPromise<void> {
            return localVarFp.linkLevelProviderAccount(id, linkLevelProvider, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a customer device
         * @param {string} token The FCM token of the device device
         * @param {string} [os] The Operative System of the device
         * @param {string} [version] The Operative System version
         * @param {string} [description] A short description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice(token: string, os?: string, version?: string, description?: string, options?: any): AxiosPromise<void> {
            return localVarFp.registerDevice(token, os, version, description, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Let customers to recover password
         * @param {string} token token send by mail
         * @param {string} newPassword The new password chose by customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePassword(token: string, newPassword: string, options?: any): AxiosPromise<void> {
            return localVarFp.restorePassword(token, newPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a notification
         * @param {string} title The title
         * @param {string} body The body
         * @param {Array<string>} tokens The target tokens
         * @param {string} bookingId The booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification(title: string, body: string, tokens: Array<string>, bookingId: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendNotification(title, body, tokens, bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a notification to all customers
         * @param {string} title The title
         * @param {string} body The body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationToAllCustomers(title: string, body: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendNotificationToAllCustomers(title, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modify customer data
         * @param {UpdateCustomerRequest} updateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateCustomerRequest: UpdateCustomerRequest, options?: any): AxiosPromise<Customer> {
            return localVarFp.update(updateCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the sport level of a customer
         * @param {number} sport The sport of the level
         * @param {number} level The value of the level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerLevel(sport: number, level: number, options?: any): AxiosPromise<void> {
            return localVarFp.updateCustomerLevel(sport, level, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Let customers to change the full name
         * @param {string} fullname The current customer password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFullName(fullname: string, options?: any): AxiosPromise<Customer> {
            return localVarFp.updateFullName(fullname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the customer gender
         * @param {number} gender The gender of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGender(gender: number, options?: any): AxiosPromise<Customer> {
            return localVarFp.updateGender(gender, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Let customers to change the nickname
         * @param {string} nickname The current customer password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNickName(nickname: string, options?: any): AxiosPromise<Customer> {
            return localVarFp.updateNickName(nickname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update phone
         * @param {string} prefix The area code
         * @param {string} value The phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhone(prefix: string, value: string, options?: any): AxiosPromise<Phone> {
            return localVarFp.updatePhone(prefix, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the customer preferences
         * @param {CustomerPreferences} customerPreferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences(customerPreferences: CustomerPreferences, options?: any): AxiosPromise<void> {
            return localVarFp.updatePreferences(customerPreferences, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update customer privacy
         * @param {Privacy} privacy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacy(privacy: Privacy, options?: any): AxiosPromise<void> {
            return localVarFp.updatePrivacy(privacy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Let customers to change their image
         * @param {any} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(image: any, options?: any): AxiosPromise<Customer> {
            return localVarFp.uploadImage(image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Service to verify email process
         * @param {string} token The token received to verify email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.verifyEmail(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Service to verify phone process
         * @param {string} token The token received to verify phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhone(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.verifyPhone(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @summary Create a customer like
     * @param {string} id Target id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public addCustomerLike(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).addCustomerLike(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new email
     * @param {string} value The email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public addEmail(value: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).addEmail(value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new phone
     * @param {string} prefix The area code
     * @param {string} value The phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public addPhone(prefix: string, value: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).addPhone(prefix, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add tenant to customer preferences
     * @param {string} id The tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public addTenantToCustomerFavorites(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).addTenantToCustomerFavorites(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Let customers to change password
     * @param {string} currentPassword The current customer password
     * @param {string} newPassword The new password chose by customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public changePassword(currentPassword: string, newPassword: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).changePassword(currentPassword, newPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check contacts against Taykus customers
     * @param {CheckContactsRequest} checkContactsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public checkContacts(checkContactsRequest: CheckContactsRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).checkContacts(checkContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a request link customer to a tenant
     * @param {string} id The tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createLinkedTenant(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createLinkedTenant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteCustomer(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete like by id
     * @param {string} id Target id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteCustomerLike(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteCustomerLike(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an email by id
     * @param {number} id The email id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteEmail(id: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteEmail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete tenant customer relation
     * @param {string} id tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteLinkedTenant(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteLinkedTenant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a phone by id
     * @param {number} id The phone id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deletePhone(id: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deletePhone(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove tenant from customer preferences
     * @param {string} id The tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteTenantFromCustomerFavorites(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteTenantFromCustomerFavorites(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a email as customer default email
     * @param {number} id The email id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public doDefaultEmail(id: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).doDefaultEmail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a phone as customer default phone
     * @param {number} id The phone id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public doDefaultPhone(id: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).doDefaultPhone(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search customers likes from a customer
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public findCustomerLikeById(start: number, size: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).findCustomerLikeById(start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search customers filtering by name, phone or email
     * @param {string} name The customer name, phone or email
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public findCustomers(name: string, start: number, size: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).findCustomers(name, start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the customer emails
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public findEmailByCustomer(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).findEmailByCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the customer tenants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public findLinkedTenantByCustomer(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).findLinkedTenantByCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find customer linked tenants
     * @param {FindCustomerLinkedTenantsRequest} findCustomerLinkedTenantsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public findLinkedTenantsByCustomer(findCustomerLinkedTenantsRequest: FindCustomerLinkedTenantsRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).findLinkedTenantsByCustomer(findCustomerLinkedTenantsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the customer phones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public findPhoneByCustomer(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).findPhoneByCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the customer data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomer(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the customer results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerResults(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerResults(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user linked tenant details
     * @param {string} id The tenant identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerTenantDetails(id: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerTenantDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get level for provider and sport
     * @param {number} id The level provider id
     * @param {number} sportId The sport code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getLevelForProviderAndSport(id: number, sportId: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getLevelForProviderAndSport(id, sportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the customer preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getPreferences(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer privacy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getPrivacy(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getPrivacy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get level provider redirect URL
     * @param {number} id The level provider id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getRedirectURL(id: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getRedirectURL(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer suggestions
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getSuggestions(size: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getSuggestions(size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start recover password process
     * @param {string} email Address where the restore password email will be sent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public initRestorePassword(email: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).initRestorePassword(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link level provider account
     * @param {number} id The level provider id
     * @param {LinkLevelProvider} linkLevelProvider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public linkLevelProviderAccount(id: number, linkLevelProvider: LinkLevelProvider, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).linkLevelProviderAccount(id, linkLevelProvider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a customer device
     * @param {string} token The FCM token of the device device
     * @param {string} [os] The Operative System of the device
     * @param {string} [version] The Operative System version
     * @param {string} [description] A short description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public registerDevice(token: string, os?: string, version?: string, description?: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).registerDevice(token, os, version, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Let customers to recover password
     * @param {string} token token send by mail
     * @param {string} newPassword The new password chose by customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public restorePassword(token: string, newPassword: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).restorePassword(token, newPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a notification
     * @param {string} title The title
     * @param {string} body The body
     * @param {Array<string>} tokens The target tokens
     * @param {string} bookingId The booking id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public sendNotification(title: string, body: string, tokens: Array<string>, bookingId: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).sendNotification(title, body, tokens, bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a notification to all customers
     * @param {string} title The title
     * @param {string} body The body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public sendNotificationToAllCustomers(title: string, body: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).sendNotificationToAllCustomers(title, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modify customer data
     * @param {UpdateCustomerRequest} updateCustomerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public update(updateCustomerRequest: UpdateCustomerRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).update(updateCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the sport level of a customer
     * @param {number} sport The sport of the level
     * @param {number} level The value of the level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateCustomerLevel(sport: number, level: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateCustomerLevel(sport, level, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Let customers to change the full name
     * @param {string} fullname The current customer password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateFullName(fullname: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateFullName(fullname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the customer gender
     * @param {number} gender The gender of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateGender(gender: number, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateGender(gender, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Let customers to change the nickname
     * @param {string} nickname The current customer password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateNickName(nickname: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateNickName(nickname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update phone
     * @param {string} prefix The area code
     * @param {string} value The phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updatePhone(prefix: string, value: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updatePhone(prefix, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the customer preferences
     * @param {CustomerPreferences} customerPreferences 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updatePreferences(customerPreferences: CustomerPreferences, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updatePreferences(customerPreferences, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update customer privacy
     * @param {Privacy} privacy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updatePrivacy(privacy: Privacy, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updatePrivacy(privacy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Let customers to change their image
     * @param {any} image 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public uploadImage(image: any, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).uploadImage(image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Service to verify email process
     * @param {string} token The token received to verify email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public verifyEmail(token: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).verifyEmail(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Service to verify phone process
     * @param {string} token The token received to verify phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public verifyPhone(token: string, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).verifyPhone(token, options).then((request) => request(this.axios, this.basePath));
    }
}
